import { prepareDate, uuid } from './helpers';

export type ISeriesSubscription = {
  created?: string;
  deleted?: boolean;
  end?: string;
  id?: string;
  series: string;
  updated?: string;
  user?: string;
  subscribed?: boolean;
};

export class SeriesSubscription {
  created: string;
  id: string;
  series: string;
  type = 'seriesSubscriptions';
  updated: string;
  user: string;
  end: string;
  subscribed: boolean;

  constructor({
    created,
    id,
    series,
    updated,
    user,
    end,
    subscribed,
    ...rest
  }: ISeriesSubscription) {
    const now = new Date();
    this.id = id ? id : uuid();
    this.series = series;
    this.user = user;
    this.created = prepareDate(created, now);
    this.updated = prepareDate(updated, now);
    this.end = prepareDate(end, null);
    this.subscribed = subscribed;
    Object.assign(this, rest); // allow old source to edit/persist properties from future versions
  }

  urlId(): string {
    return this.id;
  }
}
